/*
 * @Author: zjw
 * @Date: 2021-05-25 14:55:57
 * @LastEditTime: 2022-11-16 16:25:20
 * @FilePath: \web-app\src\network\system\user.js
 * @Environment: Vue + Element
 * @Description: 
 */
import {
    request,
} from '../request.js'

// 用户列表
export function appUserList(data) {
    return request({
        url: '/web/back/sys/user/appUserList',
        method: 'post',
        data
    })
}
